import { Popout } from 'modules/ui/popout';
import { useSidePopout } from './useSidePopout';

export const SidePopout: React.FC = () => {
  const {
    closePopout,
    popoutContainer,
    popoutVisible,
    popoutTheme,
    transitioning,
  } = useSidePopout();

  return (
    <Popout
      onClose={() => closePopout()}
      visible={popoutVisible}
      theme={popoutTheme}
      transitioning={transitioning}>
      {popoutContainer || <></>}
    </Popout>
  );
};
